<div style="border-top: 1px solid #eee;">

  <app-produto-cor *ngIf="modoVisualizacaoPageProduto != 2"></app-produto-cor>
  <app-produto-grade *ngIf="modoVisualizacaoPageProduto == 2"></app-produto-grade>

  <div *ngIf="error && errorMsg" class="mv2-alert" role="alert">
    <span>{{ errorMsg }}</span>
    <button type="button" class="mv2-alert-close" (click)="fecharAlerta()" aria-label="Fechar">
      ×
    </button>
  </div>

  <div class="saida-overlay" *ngIf="confirmacaoSaida" role="dialog" aria-modal="true" aria-labelledby="saida-titulo">
    <section class="saida-card">
      <header class="saida-header">
        <h5 id="saida-titulo">O produto não foi salvo. Confirme?</h5>
        <button type="button" class="saida-fechar" (click)="cancelarAbandono()" aria-label="Fechar">
          ×
        </button>
      </header>
      <footer class="saida-acoes">
        <button (click)="confirmarAbandono()" type="button" class="btn btn-outline-primary">
          Sair
        </button>
        <button type="button" [style.backgroundColor]="SITE.backgroundColorSliderSuperior" (click)="salvarAbandono()"
          class="btn btn-primary saida-salvar">
          Salvar e Sair
        </button>
        <button type="button" (click)="cancelarAbandono()" class="btn btn-primary saida-cancelar">
          Cancelar
        </button>
      </footer>
    </section>
  </div>
</div>